import axios from 'axios';

const API_HOST = process.env.REACT_APP_API_HOST;

async function getTimesheetsStatus() {
  const { data } = await axios.get(`${API_HOST}/v1/timesheet/stats`);
  return data;
}

async function getTimesheets() {
  const  { data }  = await axios.get(`${API_HOST}/v1/timesheet`);
  return data;
}

async function getTimesheetById (id: string){
  const  { data }  = await axios.get(`${API_HOST}/v1/timesheet/${id}`);
  return data;
}

async function makeDecision(body: any){
  const response = await axios.post(`${API_HOST}/v1/timesheet/decision`, body);
  return response
}

const createTimesheet = async (payload: {
  date: string;
  worktime: string;
  notes: string;
  breaktime: string;
}) => {
  // Adjust endpoint and method as needed
  const response = await axios.post(`${API_HOST}/v1/timesheet`, payload);
  return response.data;
};

export type TimesheetExportRequest = {
  type: 'csv' | 'xlsx';
  from?: string;
  to?: string;
  employees?: string[];
  status?: 'pending' | 'approved' | 'declined';
};

/** POST /v1/timesheet/export: the file as a blob plus its headers. */
async function exportTimesheets(body: TimesheetExportRequest) {
  const response = await axios.post(`${API_HOST}/v1/timesheet/export`, body, {
    responseType: 'blob',
  });
  return { data: response.data as Blob, headers: response.headers as any };
}

const timesheets = {
  getTimesheetsStatus,
  getTimesheets,
  getTimesheetById,
  makeDecision,
  createTimesheet,
  exportTimesheets,
};

export default timesheets;